module.exports = __webpack_public_path__ + "static/img/ANGUS-HASTIE.59e726b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ANGUS-HASTIE.jpg
// module id = WaC+
// module chunks = 0